import { gql } from "@apollo/client";
import { NOTIFICACAO_FIELDS } from "./fragments";

export const MARCAR_NOTIFICACAO_LIDA = gql`
  ${NOTIFICACAO_FIELDS}
  mutation MarcarNotificacaoLida($id: Int!) {
    marcarNotificacaoLida(id: $id) {
      ...NotificacaoFields
    }
  }
`;

export const MARCAR_TODAS_NOTIFICACOES_LIDAS = gql`
  mutation MarcarTodasNotificacoesLidas {
    marcarTodasNotificacoesLidas
  }
`;
